<span [innerHTML]="segments()"></span>
